<span [innerHTML]="segments()"></span>
